import { SVGProps } from 'react';

export const buttonIds = [
  '1',
  '2',
  '3',
  'app-connector',
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-right-circle',
  'arrow-up',
  'arrow-up-right',
  'book-open',
  'book-open-01',
  'bookmark',
  'brackets-check',
  'brain',
  'building-02',
  'building-07',
  'bullet',
  'calculator',
  'calendar',
  'calendar-date',
  'chart-breakout-circle',
  'check',
  'check-shield',
  'check-square',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'circle-check-1',
  'clipboard-check',
  'clock',
  'cloud-blank-01',
  'code-01',
  'code-02',
  'code-browser',
  'code-square-01',
  'copy',
  'cursor-box',
  'cursor-click-02',
  'data',
  'database-01',
  'dataflow-01',
  'dataflow-03',
  'dataflow-04',
  'equalizer',
  'eye',
  'face-content',
  'file-06',
  'file-attachment-02',
  'file-check-02',
  'file-plus-02',
  'flag-06',
  'flows',
  'github-mark',
  'globe-02',
  'graduation-hat-02',
  'heart',
  'intersect-circle',
  'keyboard-01',
  'layers',
  'lightbulb-05',
  'line-chart-up-02',
  'lock',
  'magic-wand-02',
  'mail-01',
  'map-01',
  'marker-pin-01',
  'medical-cross',
  'message-text-square-02',
  'monitor-04',
  'npm-logo-black',
  'package-check',
  'play-circle',
  'prismatic',
  'profile',
  'robot',
  'rocket-02',
  'route',
  'search',
  'search-refraction',
  'send-01',
  'server',
  'settings-02',
  'settings-03',
  'share-02',
  'share-07',
  'shield-tick',
  'star',
  'star-1',
  'star-2',
  'star-3',
  'star-4',
  'star-5',
  'star-6',
  'star-7',
  'star-8',
  'star-9',
  'star-fraction',
  'target-04',
  'tool-02',
  'trend-up-01',
  'upload',
  'user-check-01',
  'user-circle',
  'users-01',
  'video-recorder',
  'warning',
  'x-circle',
  'x-mark',
  'zap',
  'zap-fast',
  'zap-square',
] as const;
export type ButtonIds = (typeof buttonIds)[number];

export const miscIds = [
  'block-quote',
  'circle-check',
  'close',
  'command-prompt',
  'green-check',
  'help-circle',
  'home',
  'play',
] as const;
export type MiscIds = (typeof miscIds)[number];

export const socialIds = ['facebook', 'github', 'linkedin', 'linkedin-square', 'twitter', 'youtube'] as const;
export type SocialIds = (typeof socialIds)[number];

export type IconIds = ButtonIds | MiscIds | SocialIds;

export const iconSet = new Set<IconIds>([...buttonIds, ...miscIds, ...socialIds]);

// Alphabetically sorted icon array used in Builder UI dropdowns.
export const iconIds = Array.from(iconSet).sort((a, b) => a.localeCompare(b)) as IconIds[];

export interface IconProps extends SVGProps<SVGSVGElement> {
  /**
   * Defines which icon ID should be rendered.
   */
  icon: IconIds;
  /**
   * Supports px, percentage-based sizes or null.
   */
  size?: number | `${number}%` | null;
  /**
   * Optional accessibility label for screen readers.
   */
  label?: string;
  /**
   * Allows overriding the icon color.
   */
  iconColor?: string;
}
